<template>
  <div>
    <form @submit.prevent="submit()">
      <!-- <v-row>
        <v-col class="text-right" cols="10"></v-col>
        <v-col cols="1">
          <v-switch
            v-model="formulario.ativo"
            :label="(formulario.ativo ? 'Ativo' : 'Inativo')"
            class="sgp-toggle"
            @change="toogleStatusTarefa($event)"
          >
        </v-switch>
        </v-col>
      </v-row> -->
      <v-row>
        <v-col>
          <SGPFormSelectComponent 
            :name="'ctrl_tipo_tarefa_id'"
            :listaDeOptions="listaDeTipoTarefas"
            v-model="formulario.ctrl_tipo_tarefa_id"
            data-vv-as="Tipo de Tarefa"
            :optionLabel="'tipo'"
            :placeholder="'Tipo de Tarefa'"
            :error="validationErrors.first('ctrl_tipo_tarefa_id')"
            v-validate="'required'"
            @change="habilitarCmbMacroProcesso"
          />
        </v-col>

        <!-- 
        <v-col>
          <SGPFormSelectComponent
              :name="'ctrl_star21_pendencia_id'"
              :listaDeOptions="listaDeStar21PendenciasComNull"
              v-model="formulario.ctrl_star21_pendencia_id"
              :optionLabel="'pendencia'"
              :placeholder="'Pendência Star21'"
              :error="validationErrors.first('ctrl_star21_pendencia_id')"
          />
        </v-col> -->
        <v-col>
          <SGPFormInputComponent
              type="text"
              :name="'map'"
              v-model="formulario.map"
              :placeholder="'Map'"
              data-vv-as="Map"
              v-validate="'max:10|min:4'"
              :error="validationErrors.first('map')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <SGPFormSelectComponent 
            :name="'ctrl_workflow_id'"
            :listaDeOptions="listaDeWorkflows"
            v-model="ctrl_workflow_id"
            data-vv-as="Workflow"
            :optionLabel="'workflow'"
            :placeholder="'Workflow'"
            :error="validationErrors.first('ctrl_workflow_id')"
            @change="limparDadosProcesso($event)"
            v-validate="{required: macroProcessoRequired }"
          />
        </v-col>

        <v-col v-if="ctrl_workflow_id">
          <SGPFormSelectComponent
              :name="'ctrl_processo_id'"
              :listaDeOptions="listaDeProcessosFiltradosPorWorkflow"
              v-model="formulario.ctrl_processo_id"
              data-vv-as="Processo"
              :optionLabel="'processo'"
              :placeholder="'Processo'"
              optionSelecione="Selecione um processo"
              :error="validationErrors.first('ctrl_processo_id')"
              v-validate="'required'"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <SGPFormSelectComponent
              :name="'ctrl_tipo_aging_id'"
              :listaDeOptions="listaDeTipoAgings"
              v-model="formulario.ctrl_tipo_aging_id"
              data-vv-as="Tipo de Aging"
              :optionLabel="'tipo'"
              :placeholder="'Tipo de Aging'"
              optionSelecione="Selecione um tipo"
              :error="validationErrors.first('ctrl_tipo_aging_id')"
              v-validate="'required'"
          />
        </v-col>

        <v-col>
          <SGPFormInputComponent 
            type="text" 
            :name="'aging'"
            v-model="formulario.aging"
            :placeholder="'Aging'"
            data-vv-as="Aging"
            v-validate="'integer|required'"
            :error="validationErrors.first('aging')"
          />
        </v-col>

        <!-- <v-col>
          <SGPFormSelectComponent
              name="ctrl_star21_equipe_id"
              :listaDeOptions="listaDeEquipes"
              v-model="formulario.ctrl_star21_equipe_id"
              data-vv-as="Equipe Histórico Star"
              optionLabel="equipe"
              placeholder="Equipe Histórico Star"
              :error="validationErrors.first('ctrl_star21_equipe_id')"
              v-validate="'required'"
          />
        </v-col> -->
      </v-row>
      <v-row>
        <v-col>
          <SGPFormInputComponent 
            type="text" 
            :name="'tarefa'"
            v-model="formulario.tarefa" 
            :placeholder="'Nome da Tarefa'"
            data-vv-as="Nome da Tarefa"
            v-validate="'required|max:255'"
            :error="validationErrors.first('tarefa')"
          />
        </v-col>
        <!-- <v-col>
          <SGPFormSelectComponent 
            name="ctrl_formulario_id"
            :listaDeOptions="listaDeFormularios"
            v-model="formulario.ctrl_formulario_id"
            data-vv-as="Formulário"
            optionLabel="titulo"
            placeholder="Formulário"
          />
        </v-col> -->
      </v-row>
      <v-row>
        <v-col>
          <SGPFormSelectComponent 
            :name="'agrupavel'"
            v-model="formulario.agrupavel" 
            :placeholder="'Agrupável'"
            data-vv-as="Agrupável"
            :listaDeOptions="opcoesSelect"
            :optionLabel="'label'"
            :optionValue="'valor'"
          />
        </v-col>
        <!-- <v-col>
          <SGPFormSelectComponent 
            :name="'incluir_nova_tarefa_pco_tarefa'"
            v-model="formulario.incluir_nova_tarefa_pco_tarefa" 
            :placeholder="'Incluir nova tarefa'"
            data-vv-as="Incluir nova tarefa"
            :listaDeOptions="opcoesSelect"
            :optionLabel="'label'"
            :optionValue="'valor'"
          />
        </v-col>
        <v-col>
          <SGPFormSelectComponent 
            :name="'habilitado_extracao'"
            v-model="formulario.habilitado_extracao"
            :placeholder="'Habilitar Extração'"
            data-vv-as="Habilitar Extração"
            :listaDeOptions="opcoesSelect"
            :optionLabel="'label'"
            :optionValue="'valor'"
          />
        </v-col> -->
      </v-row>
      <v-row>
        <v-col>
          <SGPFormSelectComponent 
            :name="'mantem_bloco_apos_tratamento'"
            v-model="formulario.mantem_bloco_apos_tratamento" 
            :placeholder="'Mantém Bloco Após Tratamento'"
            data-vv-as="Mantém Bloco Após Tratamento"
            :listaDeOptions="opcoesSelect"
            :optionLabel="'label'"
            :optionValue="'valor'"
          />
        </v-col>
        <v-col>
          <SGPFormSelectComponent 
            :name="'is_last_tarefa'"
            v-model="formulario.is_last_tarefa" 
            :placeholder="'É Última Tarefa?'"
            data-vv-as="É Última Tarefa"
            :listaDeOptions="opcoesSelect"
            :optionLabel="'label'"
            :optionValue="'valor'"
          />
        </v-col>
        <v-col>
          <SGPFormSelectComponent
              :name="'contabilizar_multa'"
              v-model="formulario.contabilizar_multa"
              :placeholder="'Contabilizar multa?'"
              data-vv-as="Contabilizar multa"
              :listaDeOptions="opcoesSelect"
              :optionLabel="'label'"
              :optionValue="'valor'"
          />
        </v-col>
        <!-- <v-col>
          <SGPFormSelectComponent 
            name="instalavel"
            v-model="formulario.instalavel" 
            placeholder="Instalável"
            data-vv-as="Instalável"
            :listaDeOptions="opcoesSelect"
            :optionLabel="'label'"
            :optionValue="'valor'"
          />
        </v-col> -->
          <v-col>
            <SGPFormInputComponent 
              type="number" 
              min="0"
              :name="'ordem'"
              v-model="formulario.ordem"
              :placeholder="'Ordem de Exibição'"
              data-vv-as="Ordem"
              v-validate="'integer|required'"
              :error="validationErrors.first('ordem')"
          />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col>
            <SGPFormSelectComponent 
              name="ctrl_tarefa_responsavel_id"
              :listaDeOptions="listaDeTarefasResponsaveisAtivos"
              v-model="formulario.ctrl_tarefa_responsavel_id"
              data-vv-as="Responsavel"
              optionLabel="responsavel"
              placeholder="Responsável"
              optionSelecione="Selecione um responsavel"
              :error="validationErrors.first('ctrl_tarefa_responsavel_id')"
            />
          </v-col>  
        </v-row> -->
      <!-- <v-row>
        <v-col>
          <input 
            type="file" 
            name="'file_processo'"
            @change="onFileUpload($event)"
          />
        </v-col>
      </v-row> -->
      <v-row v-if="tarefa.url_file_processo">
        <v-col>
          <a :href="tarefa.url_file_processo" target="_blank" title="Processo">
            <img class="img-responsive" :src="tarefa.url_file_processo"  style="width:200px; height:auto;"/>
          </a>
          <div v-if="tarefa.url_file_processo" class="mdn-Checkbox" aria-label="checkbox">
              <input class="mdn-Checkbox-input" id="excluir" type="checkbox" aria-label="Label" v-model="formulario.excluir_imagem"/>
              <label class="mdn-Checkbox-label" for="excluir"></label>
              <div class="mdn-Checkbox-text" for="excluir"> Excluir Imagem</div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="container-botoes">
            <SGPFormBotaoComponent color="error" type="submit">
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </SGPFormBotaoComponent>
            
            <SGPFormBotaoComponent outlined color="grey" @click="fecharModal()">
              Cancelar
            </SGPFormBotaoComponent>
            
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CTRL_TIPO_TAREFA } from '../../../../common/boot/Constantes'

export default {
  name: "FormularioTarefaComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    tarefa: {
      type: Object,
      required: false
    }
  },
  data () {
    let disabledMacroProcesso = true;
    let ctrl_workflow_id = '';
    
    if (this.$props.tarefa && Object.keys(this.$props.tarefa).length > 0) {
      if (this.$props.tarefa.ctrl_tipo_tarefa_id && 
          this.$props.tarefa.ctrl_tipo_tarefa_id != CTRL_TIPO_TAREFA.INTERRUPCAO) {
         disabledMacroProcesso = false;
       }

      if (this.$props.tarefa.processo && this.$props.tarefa.processo.ctrl_workflow_id) {
        ctrl_workflow_id = this.$props.tarefa.processo.ctrl_workflow_id;
      }
     }

     return {
      formulario: (this.$props.tarefa && Object.keys(this.$props.tarefa).length) 
        ? { ...this.$props.tarefa } 
        : {
         tarefa: '',
        ctrl_tarefa_responsavel_id: '',
        ctrl_star21_pendencia_id: '',
        map: '',
        ctrl_processo_id: '',
        ctrl_tipo_tarefa_id: '',
        ctrl_tipo_aging_id: '',
        aging: '0',
        file_processo: '',
        excluir_imagem: '',
        ctrl_star21_equipe_id: '',
        agrupavel: '',
        mantem_bloco_apos_tratamento: '',
        is_last_tarefa: 0,
        instalavel: 1,
        habilitado_extracao: '',
        incluir_nova_tarefa_pco_tarefa: '',
        contabilizar_multa: 0,
        ordem: 0,
        ativo: 0
       },
       ctrl_workflow_id: ctrl_workflow_id,
       listagemDeProcessos: [],
       disabledMacroProcesso: disabledMacroProcesso,
       macroProcessoRequired: false,
       opcoesSelect: [
        {   
            valor : 0,
            label : 'Não' 
        },
        {   
            valor : 1,
            label : 'Sim'
        },
      ],
    }
  },
  created (){
    this.listarTipoAgings();
    this.listarTipoTarefas();
    this.listarWorkflows();
    this.listarProcessos();
    // this.listarEquipes();
    // this.filtrarProcesso();
    // this.listarTarefasFamiliasAtivas();
    // this.listarTarefasResponsaveis();
  },
  computed: {
    ...mapGetters('ctrlTarefas', [
      'listaDeTipoAgings',
      'listaDeTipoTarefas',
      'podeInativar'
    ]),
    
    ...mapGetters('ctrlWorkflow', [
      'listaDeWorkflows'
    ]),

    ...mapGetters('ctrlProcessos', [
      'listaDeProcessos'
    ]),

    // ...mapGetters('star21Pendencias', [
    //   'listaDeStar21Pendencias'
    // ]),

    // ...mapGetters('tiposTarefas', [
    //   'listaDeTiposTarefas'
    // ]),
    // ...mapGetters('processos', [
    //   'listaDeProcessos'
    // ]),
    // ...mapGetters('formularios', ['listaDeFormularios']),

    // ...mapGetters('ctrlStar21Equipes', ['listaDeEquipes']),

    // ...mapGetters('ctrlTarefasFamilias', ['listaDeTarefasFamilias']),

    // ...mapGetters('ctrlTarefasResponsaveis', ['listaDeTarefasResponsaveis']),
    
    listaDeProcessosFiltradosPorWorkflow() {
      if (!this.ctrl_workflow_id || !this.listaDeProcessos.length) {
        return [];
      }
      
      return this.listaDeProcessos.filter(
        processo => processo.ctrl_workflow_id === this.ctrl_workflow_id
      );
    },

    validarExibicaoCampoFamilia(){
      return this.formulario.ctrl_tipo_tarefa_id == CTRL_TIPO_TAREFA.INTERRUPCAO;
    },

    // listaDeTarefasResponsaveisAtivos () {
    //   return this.listaDeTarefasResponsaveis.filter(item => item.deleted_at == null)
    // },
    // listaDeStar21PendenciasComNull() {
    //     // Get the original list from the getter
    //     const originalListaDeStar21Pendencias = this.listaDeStar21Pendencias;

    //     // Create a new array that includes a null option
    //     return [{ pendencia: "-", id: null }, ...originalListaDeStar21Pendencias];
    // }
  },

  methods: {
    ...mapActions('ctrlTarefas', [
      'salvarTarefa',
      'buscarTarefa',
      'atualizarTarefa',
      'listarTipoAgings',
      'listarTipoTarefas',
      'buscaPodeInativar'
    ]),

    ...mapActions('ctrlWorkflow', [
      'listarWorkflows'
    ]),

    ...mapActions('ctrlProcessos', [
      'listarProcessos',
    ]),

    // ...mapActions('ctrlStar21Equipes', [
    //   'listarEquipes'
    // ]),

    // ...mapActions('ctrlTarefasFamilias', [
    //   'listarTarefasFamiliasAtivas'
    // ]),

    // ...mapActions('ctrlTarefasResponsaveis', [
    //   'listarTarefasResponsaveis'
    // ]),

    fecharModal () {
      // this.$emit('sgpModalFechar')
      this.$parent.$parent.$parent.$parent.fecharModal()
    },   


    onFileUpload (event) {
      this.formulario.file_processo = event.target.files[0]
    },

    validate: function () {
      this.$validator.validateAll();
    },

    limparDadosProcesso(event){
      if(typeof event == 'undefined'){
        return false;
      }

      this.formulario.ctrl_processo_id = '';
    },
    
    habilitarCmbMacroProcesso(event){
      if(typeof event == 'undefined'){
        return false;
      }

      if (this.formulario.ctrl_tipo_tarefa_id != CTRL_TIPO_TAREFA.INTERRUPCAO && this.formulario.ctrl_tipo_tarefa_id){
        this.disabledMacroProcesso = false;
        this.macroProcessoRequired = true;
        return;
      }

      this.disabledMacroProcesso = true;
      this.macroProcessoRequired = false;
      this.ctrl_workflow_id = '';
      this.formulario.ctrl_processo_id = '';
    },

    limparCampos () {
    this.formulario.tarefa = '';
    this.formulario.ctrl_star21_pendencia_id = '';
    this.formulario.map = '';
    this.formulario.ctrl_processo_id = '';
    this.formulario.ctrl_tipo_tarefa_id = '';
    this.formulario.ctrl_tipo_aging_id = '';
    this.formulario.aging = '0';
    this.formulario.ctrl_formulario_id = '';
    this.formulario.file_processo = '';
    this.formulario.excluir_imagem = '';
    this.formulario.ctrl_star21_equipe_id = '';
    this.formulario.agrupavel = '';
    this.formulario.mantem_bloco_apos_tratamento = 0;
    this.formulario.habilitado_extracao = 0;
    this.formulario.incluir_nova_tarefa_pco_tarefa = 0;
    this.formulario.instalavel = '';
    this.formulario.ctrl_tarefa_responsavel_id = '';
    this.formulario.ativo = 0;
    this.$validator.reset();
    },   

    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.formulario.ativo = (this.formulario.ativo) ? 1 : 0;
          this.formulario.is_last_tarefa = (this.formulario.is_last_tarefa) ? 1 : 0;
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarTarefa(this.formulario);            
            if(!resp) { 
              return;
            }
          }else{
            const resp = await this.atualizarTarefa(this.formulario);
            if(!resp){
              return;
            } 
          }

          //this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    async toogleStatusTarefa(val) {
      if (!val) {
        await this.buscaPodeInativar({
          ctrl_tarefa_id: this.formulario.id
        });
        if (this.podeInativar) {
          this.formulario.ativo = 0;
        } else {
          this.formulario.ativo = 1;
          this.$toast.error('Essa tarefa possui mobilidades ou tratativas cadastradas.');
        }
      }
    }
  }

}
</script>